// Other
import { inject, observer } from 'mobx-react'
import React, { useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { Link, useHistory, withRouter } from 'react-router-dom'
import { WorkPageWrapper } from './ManagementAssetWarehouseStylePage'
import DashboardLayout from '../../layouts/DashboardLayout'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import { runInAction } from 'mobx'
import ManagementAssetWarehouseTable from './ManagementAssetWarehouseTable'
// Ant design
import {
  Button,
  Menu,
  message,
  Modal,
  Col,
  Form,
  Input,
  Row,
  Select,
} from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import ManagerInventoryTemplateList from '../ManagerInventoryPage/ManagerInventoryTemplateList'
// Component
import PageTitle from '../../components/PageTitle'

// Other
import AccessControlAction from '../../components/AccessControlAction'
import ManagementAssetWarehouseCreate from './ManagementAssetWarehouseCreate'
import { ACL_ACTION_TYPE } from '../../constants'
import ManagementAssetWarehouseUnitCreate from './ManagementAssetWarehouseUnitCreate'
import ManagementAssetWarehouseUnitTable from './ManagementAssetWarehouseUnitTable'
import moment from 'moment'

const ManagementAssetWarehouseUnitPage = props => {
  const [isVisibleCreateModal, setIsVisibleCreateModal] = useState(false)
  const [currentDate] = useState(moment(new Date()).format('MM-YYYY'))

  const handleToggleCreateModal = bool => event => {
    setIsVisibleCreateModal(bool)
  }
  return (
    <WorkPageWrapper>
      <DashboardLayout>
        <Helmet>
          <title>Hành chính | Quản lý kho | Loại văn phòng phẩm</title>
        </Helmet>
        <PageTitle location={props.location}>
          <AccessControlAction check={true}>
            <Button
              type={'primary'}
              icon={<PlusOutlined />}
              onClick={handleToggleCreateModal(true)}>
              Tạo mới
            </Button>
          </AccessControlAction>
        </PageTitle>
        <ContentBlockWrapper>
          <Menu
            mode="horizontal"
            selectedKeys={props?.location?.pathname}
            style={{ marginBottom: 16 }}>
            <Menu.Item key="/manager-inventory/inventory-asset">
              <Link to={'/manager-inventory/inventory-asset'}>Tài sản</Link>
            </Menu.Item>

            <Menu.Item key="/manager-inventory/manage-inventory-asset">
              <Link to={'/manager-inventory/manage-inventory-asset'}>
                Loại văn phòng phẩm
              </Link>
            </Menu.Item>

            <Menu.Item key="/manager-inventory/statistic">
              <Link to={'/manager-inventory/statistic'}>
                Thống kê tài sản tháng {currentDate}
              </Link>
            </Menu.Item>

            <Menu.Item key="/manager-inventory/export-statistic">
              <Link to={'/manager-inventory/export-statistic'}>
                Báo cáo sử dụng văn phòng phẩm theo tháng {currentDate}
              </Link>
            </Menu.Item>
          </Menu>

          <ManagementAssetWarehouseUnitTable onSearch={isVisibleCreateModal} />
        </ContentBlockWrapper>
      </DashboardLayout>
      <Modal
        width={500}
        title={'Tạo mới loại văn phòng phẩm'}
        visible={isVisibleCreateModal}
        maskClosable={false}
        onCancel={handleToggleCreateModal(false)}
        footer={null}
        destroyOnClose>
        {isVisibleCreateModal && (
          <ManagementAssetWarehouseUnitCreate
            onCancel={handleToggleCreateModal(false)}
          />
        )}
      </Modal>
    </WorkPageWrapper>
  )
}

export default inject(
  'managementAssetWarehouseStore',
  'loadingAnimationStore',
  'authenticationStore',
  'notificationStore',
  'selectPeopleStore'
)(observer(ManagementAssetWarehouseUnitPage))
